import PropTypes from 'prop-types';
// @mui
import { Card, Typography, Stack, Button, Box } from '@mui/material';

// ----------------------------------------------------------------------

PlanCard.propTypes = {
    plan: PropTypes.object,
    SelectPlan: PropTypes.func
};

export default function PlanCard({ plan, SelectPlan }) {

  const hasTrial = plan.trial_period_days && plan.trial_period_days > 0;

  return (
    <Card sx={{ position: 'relative', overflow: 'hidden' }}>
      {/* Trial Banner */}
      {hasTrial && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '32px',
            backgroundColor: 'error.main',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2,
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
          }}
        >
          <Typography
            variant="caption"
            sx={{
              color: 'white',
              fontWeight: 'bold',
              textAlign: 'center',
              lineHeight: 1,
              fontSize: '0.75rem',
              textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
              userSelect: 'none',
            }}
          >
            {plan.trial_period_days} dias de teste grátis
          </Typography>
        </Box>
      )}

      <Stack spacing={2} sx={{ p: 3, pt: hasTrial ? 5 : 3 }}>
        <Typography variant="subtitle1" noWrap>
        {plan.name}
        </Typography>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="subtitle2">
            {plan.detail}
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="subtitle2">
            Usuarios permitidos: {plan.users_maximum}
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="subtitle2">
            Franquia mensal: {plan.envelope_cost.monthly_maximum === 0 ? "Ilimitado" : `${plan.envelope_cost.monthly_maximum} envelopes`}
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="subtitle2">
            Valor da franquia {plan.envelope_cost.billing_type === 'monthly' ? 'mensal' : 'anual'}: R$ {plan.envelope_cost.fixed_cost.toFixed(2)}
          </Typography>
        </Stack>

        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="subtitle2">
            Permitido envelope adicional: {plan.additional_envelopes_allowed ? 'Sim' : 'Não'}
          </Typography>
        </Stack> 
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="subtitle2">
            Valor por envelope adicional: R$ {plan.additional_envelopes_allowed ? plan.envelope_cost.variable_cost.toFixed(2) : '--'}
          </Typography>
        </Stack>
        <Button  variant="contained" size="large" onClick={_ => SelectPlan(plan.id)}>Selecionar</Button>
      </Stack>
    </Card>
  );
}
